<script>
    import {format} from 'date-fns';
    import {es} from 'date-fns/locale';

    import {nombreCompleto} from '../../../Modelos/Trabajador';

    import Caja from "../../UI/Caja.svelte";
    import Subtitulo from "../../UI/Subtitulo.svelte";
    import Navegacion from "../../UI/Navegacion.svelte";
    import EntradaSalida from "../../Horas/EntradaSalida.svelte";
    import Loading from "../../UI/Loading.svelte";

    import store from '../../../Stores/Trabajadores/ver-trabajador-store';

    export let fecha;
    export let tipo;

    $: trabajador = $store.trabajador.trabajador;

    $: fechaFormateada = format(fecha, 'd MMMM yyyy', {locale: es});
</script>

<style>
    dl {
        margin: 0 0 .5em;
        padding: 0;
        line-height: 1.7;
    }

    dt, dd {
        display: inline;
        margin: 0;
        padding: 0;
    }

    dt {
        font-weight: 500;
    }

    dt:after {
        content: ': ';
    }

    dt:not(:first-child):before {
        content: '\A';
        white-space: pre;
    }
</style>

<Caja>
    <div slot="titulo">
        <Subtitulo>Marcajes por día</Subtitulo>
    </div>

    <div slot="botones">
        <Navegacion on:cambio etiqueta="izquierda">
            {fechaFormateada}
        </Navegacion>
    </div>

    {#if trabajador && tipo}
        <dl>
            <dt>Día</dt>
            <dd>{fechaFormateada}</dd>
            <dt>Trabajador</dt>
            <dd>{nombreCompleto(trabajador)}</dd>
            <dt>Tipo de jornada</dt>
            <dd>{tipo ? tipo.nombre : '–'}</dd>
        </dl>

        {#if tipo && tipo.horas}
            <div class="horario">
                {#each tipo.horas as hora}
                    <EntradaSalida {hora}/>
                {/each}
            </div>
        {/if}
    {:else}
        <Loading/>
    {/if}
</Caja>
